<div class="profile-view">
  <!-- Nombre completo -->
  <section class="user-data">
    <div class="info">
      <div class="title-section">
        <div class="icon person-icon"></div>
        <h2>Nombre</h2>
      </div>
    </div>

    <div class="text-field disabled">
      <div class="content">
        <label>Nombre</label>
        <div class="value-text">
          <span class="disabled-text">{{ userPersonalInfo.fullName }}</span>
        </div>
        <!--div class="edit-input" *ngIf="isEditingFullName && isEditingMode">
          <div class="field-model">
            <input
              #fullNameInput="ngModel"
              type="text"
              [(ngModel)]="userPersonalInfo.fullName"
              required
              minlength="2"
              maxlength="100"
              class="input-field"
              (keypress)="soloLetras($event)"
              placeholder="Ingresa tu nombre completo">


          </div>

          <div *ngIf="fullNameInput.invalid && (fullNameInput.dirty || fullNameInput.touched)" style="margin-top: 8px;">
            <small style="display: block; color: red;" *ngIf="fullNameInput.errors?.['required']">
              El nombre es obligatorio.
            </small>
            <small style="display: block; color: red;" *ngIf="fullNameInput.errors?.['minlength']">
              El nombre debe tener al menos 2 caracteres.
            </small>
            <small style="display: block; color: red;" *ngIf="fullNameInput.errors?.['maxlength']">
              El nombre no debe tener más de 100 caracteres.
            </small>
          </div>
        </div-->
      </div>
    </div>
  </section>

  <!-- Fecha de nacimiento -->
  <section class="user-data right">
    <div class="info">
      <div class="title-section">
        <div class="icon calendar-icon"></div>
        <h2>Fecha de nacimiento</h2>
      </div>
    </div>

    <div class="text-field disabled">
      <div class="content">
        <label>Fecha</label>
        <div class="value-text">
          <span class="disabled-text">{{ getFormattedBirthDate() }}</span>
        </div>
        <!--div class="value-text" *ngIf="!isEditingBirthDate">
          <span [class.disabled-text]="!isEditingMode">{{ getFormattedBirthDate() }}</span>
        </div>
        <div class="edit-input" *ngIf="isEditingBirthDate && isEditingMode">
          <div class="field-model">
            <input
              matInput
              [matDatepicker]="birthDatePicker"
              [max]="maxBirthDate"
              [(ngModel)]="userPersonalInfo.birthDate"
              #birthDateInput="ngModel"
              required
              class="input-field"
              placeholder="dd/mm/yyyy"
              (input)="formatDateInput($event)"
              maxlength="10">
            <mat-datepicker-toggle [for]="birthDatePicker" class="calendar-toggle"></mat-datepicker-toggle>

          </div>
          <mat-datepicker #birthDatePicker></mat-datepicker>

          <div *ngIf="birthDateInput.invalid && (birthDateInput.dirty || birthDateInput.touched)" style="margin-top: 8px;">
            <small style="display: block; color: red;" *ngIf="birthDateInput.errors?.['required']">
              La fecha de nacimiento es obligatoria.
            </small>
          </div>
        </div-->
      </div>
    </div>
  </section>

  <!-- Número de celular -->
  <section class="user-data">
    <div class="info">
      <div class="title-section">
        <div class="icon phone-icon"></div>
        <h2>Teléfono móvil</h2>
      </div>
    </div>

    <div class="text-field" [class.disabled]="!isEditingMode">
      <div class="content">
        <label>Principal</label>
        <div class="value-text" *ngIf="!isEditingPhone">
          <span [class.disabled-text]="!isEditingMode">{{ userPhone.primary }}</span>
        </div>
        <div class="edit-input" *ngIf="isEditingPhone && isEditingMode">
          <div class="field-model">
            <input
            #phoneInput="ngModel"
            type="tel"
            [(ngModel)]="userPhone.primary"
            required
            minlength="10"
            maxlength="10"
            class="input-field"
            (keypress)="soloNumeros($event)"
            placeholder="Ingresa tu número principal">


          </div>


          <div *ngIf="phoneInput.invalid && (phoneInput.dirty || phoneInput.touched)" style="margin-top: 8px;">
            <small style="display: block; color: red;" *ngIf="phoneInput.errors?.['required']">
              El teléfono es obligatorio.
            </small>
            <small style="display: block; color: red;" *ngIf="phoneInput.errors?.['minlength']">
              El teléfono debe tener al menos 10 dígitos.
            </small>
            <small style="display: block; color: red;" *ngIf="phoneInput.errors?.['maxlength']">
              El teléfono no debe tener más de 10 dígitos.
            </small>
          </div>
        </div>
      </div>
    </div>

    <div class="text-field add-field" *ngIf="!showAdditionalPhone" hidden>
      <div class="content">
        <span>número adicional</span>
        <div class="add-icon" (click)="addAdditionalPhone()"></div>
      </div>
    </div>

    <div class="text-field" *ngIf="showAdditionalPhone" hidden>
      <div class="content">
        <label>Adicional</label>
        <div class="value-text" *ngIf="!isEditingAdditionalPhone">
          <span>{{ userPhone.additional }}</span>
          <div class="edit-icon" (click)="toggleAdditionalPhoneEdit()"></div>
        </div>
        <div class="edit-input" *ngIf="isEditingAdditionalPhone">
          <div class="field-model">
            <input
              #additionalPhoneInput
              type="tel"
              [(ngModel)]="userPhone.additional"
              class="input-field"
              placeholder="Ingresa tu número adicional"

            #telefonoModelAnother="ngModel"
            required
            minlength="10"
            maxlength="11"
              (keyup.enter)="saveAdditionalPhoneChanges()">
            <div class="save-icon" (click)="saveAdditionalPhoneChanges()"></div>
          </div>

          <div *ngIf="telefonoModelAnother.invalid && (telefonoModelAnother.dirty || telefonoModelAnother.touched)" style="margin-top: 8px;">
            <small style="display: block; color: red;" *ngIf="telefonoModelAnother.errors?.['required']">
              El teléfono es obligatorio.
            </small>
            <small style="display: block; color: red;" *ngIf="telefonoModelAnother.errors?.['minlength']">
              El teléfono debe tener al menos 10 dígitos.
            </small>
            <small style="display: block; color: red;" *ngIf="telefonoModelAnother.errors?.['maxlength']">
              El teléfono no debe tener más de 15 dígitos.
            </small>
          </div>

        </div>
      </div>
    </div>
  </section>

  <!-- Correo electrónico -->
  <section class="user-data right">
    <div class="info">
      <div class="title-section">
        <div class="icon mail-icon"></div>
        <h2>Correo electrónico</h2>
      </div>
    </div>

    <div class="text-field disabled">
      <div class="content">
        <label>Principal</label>
        <div class="value-text">
          <span class="disabled-text">{{ userEmail.primary }}</span>
        </div>
      </div>
    </div>

    <div class="text-field add-field" *ngIf="!showAdditionalEmail" hidden>
      <div class="content">
        <span>correo electrónico adicional</span>
        <div class="add-icon" (click)="addAdditionalEmail()"></div>
      </div>
    </div>

    <div class="text-field" *ngIf="showAdditionalEmail" hidden>
      <div class="content">
        <label>Adicional</label>
        <div class="value-text" *ngIf="!isEditingAdditionalEmail">
          <span>{{ userEmail.additional }}</span>
          <div class="edit-icon" (click)="toggleAdditionalEmailEdit()"></div>
        </div>
        <div class="edit-input" *ngIf="isEditingAdditionalEmail">
          <div class="field-model">
            <input
            #additionalEmailInput="ngModel"
            type="email"
            [(ngModel)]="userEmail.additional"
            name="additionalEmail"
            class="input-field"
            placeholder="Ingresa tu correo adicional"
            email
            required
            minlength="5"
            maxlength="50"
            (keyup.enter)="saveAdditionalEmailChanges()">
            <div class="save-icon" (click)="saveAdditionalEmailChanges()"></div>
          </div>
          <!-- Validation messages -->
          <div *ngIf="additionalEmailInput.invalid && (additionalEmailInput.dirty || additionalEmailInput.touched)" style="margin-top: 8px;">
            <small style="display: block; color: red;" *ngIf="additionalEmailInput.errors?.['required']">
              El correo es obligatorio.
            </small>
            <small style="display: block; color: red;" *ngIf="additionalEmailInput.errors?.['email']">
              El formato del correo no es válido.
            </small>
            <small style="display: block; color: red;"*ngIf="additionalEmailInput.errors?.['minlength']">
              El correo debe tener al menos 5 caracteres.
            </small>
            <small style="display: block; color: red;" *ngIf="additionalEmailInput.errors?.['maxlength']">
              El correo no puede superar los 50 caracteres.
            </small>
          </div>
        </div>
      </div>
    </div>
  </section>



  <!-- Preferencias -->
  <section class="user-data preferences pt-3">
    <div class="info">
      <div class="title-section py-3">
        <div class="icon options-icon"></div>
        <h2 class="">Preferencias</h2>
      </div>
    </div>

    <div class="fields">
      <div class="field">
        <label class="field-label pt-3">Método de contacto</label>
        <div class="options" [class.disabled]="!isEditingMode">
          <div class="option" (click)="isEditingMode ? setContactMethod('email') : null" [class.disabled]="!isEditingMode">
            <div class="radio-button" [class.selected]="contactMethod === 'email'"></div>
            <span [class.disabled-text]="!isEditingMode">Correo electrónico</span>
          </div>

          <div class="option" (click)="isEditingMode ? setContactMethod('whatsapp') : null" [class.disabled]="!isEditingMode">
            <div class="radio-button" [class.selected]="contactMethod === 'whatsapp'"></div>
            <span [class.disabled-text]="!isEditingMode">WhatsApp</span>
          </div>

          <!--div class="option" (click)="isEditingMode ? setContactMethod('both') : null" [class.disabled]="!isEditingMode">
            <div class="radio-button" [class.selected]="contactMethod === 'both'"></div>
            <span [class.disabled-text]="!isEditingMode">Ambos</span>
          </div-->
        </div>
      </div>
    </div>
  </section>

  <!-- Botón Editar -->
  <div class="edit-button-container">
    <button class="edit-button" (click)="isEditingMode ? saveAllChanges() : toggleEditMode()">
      {{ isEditingMode ? 'Guardar' : 'Editar' }}
    </button>
  </div>

  <!-- Divider -->
  <div class="section-divider"></div>

  <section class="user-data preferences pt-3">
    <div class="field pt-1">
      <label class="field-label">Contraseña</label>
      <button class="change-password" (click)="requestPasswordChange()">Solicitar cambio de contraseña</button>
    </div>
  </section>
</div>

<!-- Loader -->
<app-screen-loader *ngIf="isLoading | async"></app-screen-loader>
